import React, {useEffect, useCallback} from "react";
import {useLocation, useNavigate} from "react-router-dom";
//import Password from "./password";
import {useDiaForm} from "./dia-form";
import {hookReturn} from '../utils';
import {useUserContext} from "../contexts/user-context";
import {ModalWindow} from "./ModalWindow";
import {Button, IconButton, TextField} from "@mui/material";
import {Visibility, VisibilityOff, Fingerprint} from "@mui/icons-material";
import WaitSpinner from "./wait-spinner";
import { useToast } from "../contexts/toast";

//var Password = Input.Password;

const inputValues = {password: '', username: '', id: 'form'};

const Login = () => {
    const navigate = useNavigate()
    const location = useLocation();
    const userContext = useUserContext();
    const { toast } = useToast();

    const [showPassword, setShowPassword] = React.useState(false);
    useEffect(() => {
        console.log('LOGIN NAVIGATE');
        if (location.pathname == '/logout') {
            navigate('/');
        }
    }, []);

    const submit = useCallback(async ({values, hasCompleted}) => {
        const result = await userContext.doLogin(values);
        hasCompleted(); // clear the status flag
    }, [userContext]);

    const diaForm = useDiaForm({
        inputValues: inputValues,
        onSubmit: submit,
        loaded:true
    });
    useEffect(() => {
        console.log('hooking?');
        return hookReturn(diaForm.handleSubmit);
    }, []);
    const input = {
        onChange: diaForm.onChange
    };
    const handleClickShowPassword = () => {
        setShowPassword((v) => !v);
    }
    if (diaForm.status != 'ready') {
        return <WaitSpinner variant="panel"/>;
    }
    return (
        <ModalWindow isOpen={true} onClose={null} header={
            "Login"
        } actions={
            <Button onClick={diaForm.handleSubmit} color="primary" variant="contained">Login</Button>
        }>
            <div className="grid12" style={{margin: 'auto'}}>
                <TextField name="username" label="Username" {...input} value={diaForm.values?.username??''}
                            className="grid12-8"/>
                <TextField label="Password" {...input}
                           type={showPassword ? 'text' : 'password'}
                           value={diaForm.values?.password??''}
                           name="password"
                           className="grid12-8 grid12-clear"
                            InputProps={{
                                endAdornment:
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        edge="end"
                                    >{showPassword ? <VisibilityOff/> : <Visibility/>}
                                    </IconButton>
                            }}
                 />
                <Button variant="outlined" startIcon={<Fingerprint/>}
                        onClick={()=>{ userContext.doPasskeyLogin(); }}
                        className="grid12-8 grid12-clear"
                        style={{marginTop: 8}}>
                    Use passkey
                </Button>
            </div>
        </ModalWindow>
    );
}

export default Login;
